export default "__VITE_ASSET__C$8SQ3MM__"